/* Invitation de l'accueil : aucun appel réseau, aucun suivi publicitaire. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  var dialog = document.querySelector('[data-calendrier-invitation]');
  if (!dialog || dialog.dataset.invitationReady || typeof dialog.showModal !== 'function') return;
  dialog.dataset.invitationReady = 'true';

  var key = 'chanoyu.calendrier2026.invitation.until';
  var sevenDays = 7 * 24 * 60 * 60 * 1000;
  var stores = [];
  try { stores.push(window.localStorage); } catch (_) {}
  try { stores.push(window.sessionStorage); } catch (_) {}
  function wasSeen() {
    if (window.__chanoyuCalendarInvitationSeen) return true;
    return stores.some(function (store) {
      try { return Number(store.getItem(key)) > Date.now(); } catch (_) { return false; }
    });
  }
  function remember() {
    window.__chanoyuCalendarInvitationSeen = true;
    var until = String(Date.now() + sevenDays);
    stores.forEach(function (store) { try { store.setItem(key, until); } catch (_) {} });
  }

  var delay = Math.max(8, Math.min(30, Number(dialog.dataset.delay) || 12)) * 1000;
  var activeTime = 0;
  var previousTick = performance.now();
  var lastActivity = 0;
  var interacted = false;
  var returnFocus = null;
  var shown = false;
  var events = ['pointerdown', 'pointermove', 'keydown', 'scroll', 'touchstart'];
  var timer;
  var blockerSelector = [
    'dialog[open]', '[role="dialog"]', '[aria-modal="true"]',
    '[data-tiroir]:not([hidden])', '[data-menu-mobile]:not([hidden])',
    '[data-recherche-bandeau]:not([hidden])',
    '[data-entete] [aria-expanded="true"]',
    '#shopify-pc__banner', '#shopify-pc__prefs', '.shopify-pc__banner__dialog',
    '[data-cookie-banner]', '[data-consent-banner]', '[data-testid="cookie-banner"]',
    '#onetrust-banner-sdk', '#CybotCookiebotDialog', '.cc-window:not(.cc-invisible)'
  ].join(',');

  function isVisible(element) {
    if (element === dialog || dialog.contains(element) || element.closest('[hidden], [aria-hidden="true"], [inert]')) return false;
    var rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= window.innerHeight) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0;
  }
  function isBlocked() {
    if (document.hidden || !document.hasFocus()) return true;
    var focused = document.activeElement;
    if (focused && focused.matches('input, textarea, select, [contenteditable="true"]')) return true;
    return Array.prototype.some.call(document.querySelectorAll(blockerSelector), isVisible);
  }
  function activity(event) {
    if (!event.isTrusted) return;
    interacted = true;
    lastActivity = performance.now();
  }
  function cleanUp() {
    clearInterval(timer);
    events.forEach(function (name) { document.removeEventListener(name, activity, true); });
    document.removeEventListener('visibilitychange', visibilityChanged);
    window.removeEventListener('storage', storageChanged);
  }
  function visibilityChanged() { previousTick = performance.now(); }
  function storageChanged(event) {
    if (event.key === key && wasSeen() && !shown) cleanUp();
  }
  function restoreFocus() {
    if (returnFocus && returnFocus.isConnected && typeof returnFocus.focus === 'function') {
      returnFocus.focus({ preventScroll: true });
    }
  }
  function tick() {
    var now = performance.now();
    var elapsed = Math.min(1000, now - previousTick);
    previousTick = now;
    if (wasSeen()) { cleanUp(); return; }
    if (!interacted || now - lastActivity > 60000 || isBlocked()) return;
    activeTime += elapsed;
    if (activeTime < delay) return;
    // The image must be ready before the modal takes focus.
    var image = dialog.querySelector('img');
    if (image && (!image.complete || !image.naturalWidth)) {
      image.loading = 'eager';
      return;
    }
    returnFocus = document.activeElement;
    try { dialog.showModal(); } catch (_) { cleanUp(); return; }
    shown = true;
    remember();
    cleanUp();
    document.documentElement.classList.add('calendrier-invitation-ouverte');
    var heading = dialog.querySelector('h2');
    if (heading) heading.focus({ preventScroll: true });
  }

  dialog.querySelectorAll('[data-invitation-fermer]').forEach(function (button) {
    button.addEventListener('click', function () { dialog.close(); });
  });
  dialog.addEventListener('close', function () {
    remember();
    document.documentElement.classList.remove('calendrier-invitation-ouverte');
    restoreFocus();
  });
  dialog.querySelector('[data-invitation-decouvrir]').addEventListener('click', remember);
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    var rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  // Escape and focus containment are handled by the browser's native dialog.
  // Keep dismissal available when a preview opens an invitation already seen.
  if (wasSeen()) return;
  events.forEach(function (name) { document.addEventListener(name, activity, { capture: true, passive: true }); });
  document.addEventListener('visibilitychange', visibilityChanged);
  window.addEventListener('storage', storageChanged);
  window.addEventListener('pagehide', cleanUp, { once: true });
  timer = setInterval(tick, 500);
})();
